export const SET_PRE_EMBAUCHE_LOADING = "SET_PRE_EMBAUCHE_LOADING";
export const SET_PRE_EMBAUCHE_ERROR = "SET_PRE_EMBAUCHE_ERROR";

export const FETCH_PRE_EMBAUCHE_DOCUMENT_REQUEST = "FETCH_PRE_EMBAUCHE_DOCUMENT_REQUEST";
export const FETCH_PRE_EMBAUCHE_DOCUMENT_SUCCESS = "FETCH_PRE_EMBAUCHE_DOCUMENT_SUCCESS";
export const FETCH_PRE_EMBAUCHE_DOCUMENT_FAIL = "FETCH_PRE_EMBAUCHE_DOCUMENT_FAIL";

export const GENERATE_PRE_EMBAUCHE_DOCUMENT_REQUEST = "GENERATE_PRE_EMBAUCHE_DOCUMENT_REQUEST";
export const GENERATE_PRE_EMBAUCHE_DOCUMENT_SUCCESS = "GENERATE_PRE_EMBAUCHE_DOCUMENT_SUCCESS";
export const GENERATE_PRE_EMBAUCHE_DOCUMENT_FAIL = "GENERATE_PRE_EMBAUCHE_DOCUMENT_FAIL";

export const UPDATE_PRE_EMBAUCHE_DOCUMENT_REQUEST = "UPDATE_PRE_EMBAUCHE_DOCUMENT_REQUEST";
export const UPDATE_PRE_EMBAUCHE_DOCUMENT_SUCCESS = "UPDATE_PRE_EMBAUCHE_DOCUMENT_SUCCESS";
export const UPDATE_PRE_EMBAUCHE_DOCUMENT_FAIL = "UPDATE_PRE_EMBAUCHE_DOCUMENT_FAIL";

export const EXPORT_PRE_EMBAUCHE_DOCUMENT_PDF_REQUEST = "EXPORT_PRE_EMBAUCHE_DOCUMENT_PDF_REQUEST";
export const EXPORT_PRE_EMBAUCHE_DOCUMENT_PDF_SUCCESS = "EXPORT_PRE_EMBAUCHE_DOCUMENT_PDF_SUCCESS";
export const EXPORT_PRE_EMBAUCHE_DOCUMENT_PDF_FAIL = "EXPORT_PRE_EMBAUCHE_DOCUMENT_PDF_FAIL";

export const UPDATE_PRE_EMBAUCHE_PROCEDURE_STEP_REQUEST = "UPDATE_PRE_EMBAUCHE_PROCEDURE_STEP_REQUEST";
export const UPDATE_PRE_EMBAUCHE_PROCEDURE_STEP_SUCCESS = "UPDATE_PRE_EMBAUCHE_PROCEDURE_STEP_SUCCESS";
export const UPDATE_PRE_EMBAUCHE_PROCEDURE_STEP_FAIL = "UPDATE_PRE_EMBAUCHE_PROCEDURE_STEP_FAIL";

export const setPreEmbaucheLoading = (key, value) => ({
    type: SET_PRE_EMBAUCHE_LOADING,
    payload: { key, value },
});

export const setPreEmbaucheError = (key, error) => ({
    type: SET_PRE_EMBAUCHE_ERROR,
    payload: { key, error },
});

export const fetchPreEmbaucheDocumentRequest = (documentType, candidatureId) => ({
    type: FETCH_PRE_EMBAUCHE_DOCUMENT_REQUEST,
    payload: { documentType, candidatureId },
});

export const fetchPreEmbaucheDocumentSuccess = (documentType, candidatureId, data) => ({
    type: FETCH_PRE_EMBAUCHE_DOCUMENT_SUCCESS,
    payload: { documentType, candidatureId, data },
});

export const fetchPreEmbaucheDocumentFail = (documentType, candidatureId, error) => ({
    type: FETCH_PRE_EMBAUCHE_DOCUMENT_FAIL,
    payload: { documentType, candidatureId, error },
});

export const generatePreEmbaucheDocumentRequest = (documentType, candidatureId, document) => ({
    type: GENERATE_PRE_EMBAUCHE_DOCUMENT_REQUEST,
    payload: { documentType, candidatureId, document },
});

export const generatePreEmbaucheDocumentSuccess = (documentType, candidatureId, data) => ({
    type: GENERATE_PRE_EMBAUCHE_DOCUMENT_SUCCESS,
    payload: { documentType, candidatureId, data },
});

export const generatePreEmbaucheDocumentFail = (documentType, candidatureId, error) => ({
    type: GENERATE_PRE_EMBAUCHE_DOCUMENT_FAIL,
    payload: { documentType, candidatureId, error },
});

export const updatePreEmbaucheDocumentRequest = (documentType, candidatureId, document) => ({
    type: UPDATE_PRE_EMBAUCHE_DOCUMENT_REQUEST,
    payload: { documentType, candidatureId, document },
});

export const updatePreEmbaucheDocumentSuccess = (documentType, candidatureId, data) => ({
    type: UPDATE_PRE_EMBAUCHE_DOCUMENT_SUCCESS,
    payload: { documentType, candidatureId, data },
});

export const updatePreEmbaucheDocumentFail = (documentType, candidatureId, error) => ({
    type: UPDATE_PRE_EMBAUCHE_DOCUMENT_FAIL,
    payload: { documentType, candidatureId, error },
});

export const exportPreEmbaucheDocumentPdfRequest = (documentType, candidatureId, document) => ({
    type: EXPORT_PRE_EMBAUCHE_DOCUMENT_PDF_REQUEST,
    payload: { documentType, candidatureId, document },
});

export const exportPreEmbaucheDocumentPdfSuccess = (documentType, candidatureId, data) => ({
    type: EXPORT_PRE_EMBAUCHE_DOCUMENT_PDF_SUCCESS,
    payload: { documentType, candidatureId, data },
});

export const exportPreEmbaucheDocumentPdfFail = (documentType, candidatureId, error) => ({
    type: EXPORT_PRE_EMBAUCHE_DOCUMENT_PDF_FAIL,
    payload: { documentType, candidatureId, error },
});

export const updatePreEmbaucheProcedureStepRequest = (candidatureId, stepId, step, document) => ({
    type: UPDATE_PRE_EMBAUCHE_PROCEDURE_STEP_REQUEST,
    payload: { candidatureId, stepId, step, documentType: "procedureIntegration", document },
});

export const updatePreEmbaucheProcedureStepSuccess = (candidatureId, data) => ({
    type: UPDATE_PRE_EMBAUCHE_PROCEDURE_STEP_SUCCESS,
    payload: { documentType: "procedureIntegration", candidatureId, data },
});

export const updatePreEmbaucheProcedureStepFail = (candidatureId, error) => ({
    type: UPDATE_PRE_EMBAUCHE_PROCEDURE_STEP_FAIL,
    payload: { documentType: "procedureIntegration", candidatureId, error },
});
